import {BaseTrackingEvent} from '@udemy-v2/event-tracking';

export class VariationGroupPresented implements BaseTrackingEvent {
    readonly _type = 'VariationGroupPresented';
    courseId: number;
    variationGroupId: number;

    constructor({courseId, variationGroupId}: {courseId: number; variationGroupId: number}) {
        this.courseId = courseId;
        this.variationGroupId = variationGroupId;
    }
}

export class VariationGroupItemSelected implements BaseTrackingEvent {
    readonly _type = 'VariationGroupItemSelected';
    courseId: number;
    selectedVariantCourseId: number;
    variationGroupId: number;

    constructor({
        courseId,
        selectedVariantCourseId,
        variationGroupId,
    }: {
        courseId: number;
        selectedVariantCourseId: number;
        variationGroupId: number;
    }) {
        this.courseId = courseId;
        this.selectedVariantCourseId = selectedVariantCourseId;
        this.variationGroupId = variationGroupId;
    }
}
